import { render, staticRenderFns } from "./modal.vue?vue&type=template&id=3cdc5951&scoped=true&lang=pug&"
import script from "./modal.vue?vue&type=script&lang=js&"
export * from "./modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdc5951",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cdc5951')) {
      api.createRecord('3cdc5951', component.options)
    } else {
      api.reload('3cdc5951', component.options)
    }
    module.hot.accept("./modal.vue?vue&type=template&id=3cdc5951&scoped=true&lang=pug&", function () {
      api.rerender('3cdc5951', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/src/components/common/modal.vue"
export default component.exports